import React from 'react';
import { Branding } from './Branding';

const ServicetjekBranding = () => {
	return (
		<div style={ { position: 'absolute', left: 0, right: 0, zIndex: -1 } }>
			<Branding />
		</div>
	);
};

export default ServicetjekBranding;
